"use client";
// components/RotatingEmoji.jsx

import { useState, useEffect } from "react";

export default function RotatingEmoji({ emojis }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!Array.isArray(emojis)) return;
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % emojis.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [emojis]);

  return <span>{Array.isArray(emojis) ? emojis[index] : emojis}</span>;
}